










import { Component, Mixins } from "vue-property-decorator";
import { StandardOption } from "../../system/selectors/mixins";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import HostNameEditor from "./localStorage/HostNameEditor.vue";
import DeveloperModeEditor from "./localStorage/DeveloperModeEditor.vue";

@Component({
  components: {
    OptionDropDownSelector,
    HostNameEditor,
    DeveloperModeEditor,
  }
})
export default class LocalStorageEditor extends Mixins() {
  data(): any {
    return {
      contents: [
        new StandardOption<string>("hostName", "host-name-editor"),
        new StandardOption<string>("isDeveloperMode", "developer-mode-editor"),
      ],
      selectedContent: "host-name-editor",
    };
  }
  contents: StandardOption<string>[];
  selectedContent: string;

  selectContent(key: string): void {
    this.selectedContent = key;
  }
}
